import MasterService from "./MasterService";

const ReconciliationService = {
    ...MasterService,

    getLeadListing(params: object) {
        return this.post('/lead/lead-List', params)
    },

    getLeadDeatil(params: object) {
        return this.post('/lead/lead-detail', params)
    },

    leadApproveReject(params: object) {
         return this.post('/lead/lead-status-update', params)
    },

    getDashboardCount() {
         return this.get('/lead/dashboard-list')
    },

    leadDocumentResubmit(params: object) {
         return this.post('/lead/request_submit_document',params)
    }
}

export default ReconciliationService;